namespace $.$$ {
	export class $eve_app_page_components_pagination extends $.$eve_app_page_components_pagination {}
}
